import {SquadflixCollectionResp} from "../../components/app/myProfileView/my-profile-subroutes/my-profile-lists/types";
import {ApiFunction, ChatbotApi} from "../chatbot/towersChatbotApi";

export class SquadflixCollectionsApi {
    static async getCollectionDetails({collectionId, page}): Promise<SquadflixCollectionResp> {
        const fn = new ApiFunction('getCollectionDetails', ChatbotApi.baseUrl);
        return fn.call({collectionId, page});
    }

    static async getMyCollections() {
        const fn = new ApiFunction('getMyCollections', ChatbotApi.baseUrl);
        return fn.call();
    }

    static async getUserPublicCollections({userId}) {
        const fn = new ApiFunction('getUserPublicCollections', ChatbotApi.baseUrl);
        return fn.call({userId});
    }

    static async getMyCollectionsSummary() {
        const fn = new ApiFunction('getMyCollectionsSummary', ChatbotApi.baseUrl);
        return fn.call();
    }

    static async createCollection({name, isPrivate}) {
        const fn = new ApiFunction('createSquadflixCollection', ChatbotApi.baseUrl);
        return fn.call({name, isPrivate});
    }

    static async addItemToCollection({collectionId, isMovie, tmdbId, episode, season}) {
        const fn = new ApiFunction('addItemToCollection', ChatbotApi.baseUrl);
        return fn.call({collectionId, isMovie, tmdbId, episode, season});
    }

    static async deleteCollection({collectionId}) {
        const fn = new ApiFunction('deleteSquadflixCollection', ChatbotApi.baseUrl);
        return fn.call({collectionId});
    }

    static async removeItemFromCollection({collectionId, isMovie, tmdbId, episode, season}) {
        const fn = new ApiFunction('removeItemFromCollection', ChatbotApi.baseUrl);
        return fn.call({collectionId, isMovie, tmdbId, episode, season});
    }

    static async updateCollectionPrivacy({collectionId, isPrivate}) {
        const fn = new ApiFunction('updateCollectionPrivacy', ChatbotApi.baseUrl);
        return fn.call({collectionId, isPrivate});
    }

    static async updateCollectionName({collectionId, name}) {
        const fn = new ApiFunction('updateCollectionName', ChatbotApi.baseUrl);
        return fn.call({collectionId, name});
    }
}
